namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class UserDialog extends Serenity.EntityDialog<UserRow, any> {
        protected getFormKey() { return UserForm.formKey; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getIsActiveProperty() { return UserRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getNameProperty() { return UserRow.nameProperty; }
        protected getService() { return UserService.baseUrl; }

        protected form = new UserForm(this.idPrefix);
        private unlockUser: string;

        get UnlockUsers()
        {
            return this.unlockUser;
        }

        set UnlockUsers(value: string) {
            if (this.unlockUser != value) {
                this.unlockUser = value;
            }
            console.log('unlockUser: ' + this.unlockUser);
        }

        constructor() {
            super();


            this.form.Password.change(e => {
                let b =  Q.toId(this.form.Password.value )
                if(b != null){
                    var a =this.check(this.form.Password.value);
                    if (a) {
    
                    }
                }
            })

            this.form.Password.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value.length < 8) {
                    return "Password must be at least 8 characters!";
                }
                // var a =this.check(this.form.Password.value);
                // if (a) {

                // }

                               

            });

            this.form.PasswordConfirm.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value != this.form.PasswordConfirm.value)
                    return "The passwords entered doesn't match!";
            });
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            buttons.push({
                title: Q.text('Site.UserDialog.EditPermissionsButton'),
                cssClass: 'edit-permissions-button',
                icon: 'fa-lock text-green',
                onClick: () => {
                    new UserPermissionDialog({
                        userID: this.entity.UserId,
                        username: this.entity.Username
                    }).dialogOpen();
                }
            });

            buttons.push({
                title: 'Unlock User',
                icon: 'fa-lock text-red',
                cssClass: 'unlock-user-button',
                onClick: () => {

                    // const dlg = new UnlockUserDialog();
                    // dlg.UnlockUser = this.form.UserActive.value;
                    // dlg.Username = this.form.Username.value;
                    
                    // dlg.dialogOpen();
                    console.log(this.entity.UserId)
                    
                        UnlockUserService.PosUnlockUser({
                            Username: this.form.Username.value,
                            UserActive: "0",
                            UserId: this.entity.UserId,
                        });
                    Q.notifySuccess('Success');    

                },
                separator: true,
            });

            return buttons;
        }

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton("edit-permissions-button").toggleClass("disabled", this.isNewOrDeleted());
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // var userId = Authorization.userDefinition.Username;
            // var userId = Authorization.userDefinition.Username;
            // if(userId == "admin" ){

            // }else{
            //     this.form.Password.getGridField().toggle(false);
            //     this.form.PasswordConfirm.getGridField().toggle(false);
            // }
            

            // let shop = Q.first(QRreport.QRywcSpecRow.getLookup().items, x => x.ShopId== "2" && x.CashierId).ShopId;
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.SysName== "Approval" && x.SysFg > 0)
            console.log(app)
            if(app !=null){
                this.form.ApprGroupCode.getGridField().toggle(true);
            }else{
                this.form.ApprGroupCode.getGridField().toggle(false);
            }



            // these fields are only required in new record mode
            this.form.Password.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());
            this.form.PasswordConfirm.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());


        }
        private check (password: string){

            let o = new PasswordCheckService();
            // password = this.form.Password.value

            var a=o.checkPasswordStrength(password)
            if(a<3){                
                 if(a == 0){
                    Q.warning("Password must be at least 8 characters!")
                }
                if(a == 1){
                    Q.warning("Password is to common.")
                }
                if(a == 2){
                    Q.warning("Password must have Lowercase, Uppercase, Numbers and Special characters characters!")
                }
                
                return false

            }else{ return true}

        } 

        
    }

    export const enum PasswordCheckStrength {
        Short,
        Common,
        Weak,
        Ok,
        Strong,
    };
    
    // Object to check password strengths and various properties
    export class PasswordCheckService {
    
        // Expected length of all passwords
        public static get MinimumLength(): number {
            return 8;
        }
    
        // Regex to check for a common password string - all based on 5+ length passwords
        private commonPasswordPatterns = /passw.*|12345.*|09876.*|qwert.*|asdfg.*|zxcvb.*|footb.*|baseb.*|drago.*/;
    
        //
        // Checks if the given password matches a set of common password
        //
        public isPasswordCommon(password: string): boolean {
            return this.commonPasswordPatterns.test(password);
        }
    
        //
        // Returns the strength of the current password
        //
        public checkPasswordStrength(password: string): PasswordCheckStrength {
    
            // Build up the strenth of our password
            let numberOfElements = 0;
            numberOfElements = /.*[a-z].*/.test(password) ? ++numberOfElements : numberOfElements;      // Lowercase letters
            numberOfElements = /.*[A-Z].*/.test(password) ? ++numberOfElements : numberOfElements;      // Uppercase letters
            numberOfElements = /.*[0-9].*/.test(password) ? ++numberOfElements : numberOfElements;      // Numbers
            numberOfElements = /[^a-zA-Z0-9]/.test(password) ? ++numberOfElements : numberOfElements;   // Special characters (inc. space)
            numberOfElements = /^(?=.{7,})([a-z\d])[a-z\d]*(?!\1)([a-z\d])[a-z\d]*(?!\1|\2)([a-z\d])[a-z\d]*(?!\1|\2|\3)([a-z\d])[a-z\d]*(?!\1|\2|\3|\4)([a-z\d])[a-z\d]*$/.test(password) ? ++numberOfElements : numberOfElements; 
            
    
            // Assume we have a poor password already
            let currentPasswordStrength = PasswordCheckStrength.Short;
    
            // Check then strenth of this password using some simple rules
            if (password === null || password.length < PasswordCheckService.MinimumLength) {
                currentPasswordStrength = PasswordCheckStrength.Short;
            } else if (this.isPasswordCommon(password) === true) {
                currentPasswordStrength = PasswordCheckStrength.Common;
            } else if (numberOfElements === 0 || numberOfElements === 1 || numberOfElements === 2 ) {
                currentPasswordStrength = PasswordCheckStrength.Weak;
            } else if (numberOfElements === 3) {
                currentPasswordStrength = PasswordCheckStrength.Ok;
            } else {
                currentPasswordStrength = PasswordCheckStrength.Strong;
            }
    
            // Return the strength of this password
            return currentPasswordStrength;
        }
    }
}